import React from 'react';
import { IFeed } from './interfaces';
import { Box } from '@mui/material';
import { PostMessageSection } from './components/PostMessageSection';

export const Feed: React.FC<IFeed> = ({
  children,
  postAuthor,
  onMessagePost,
  sx,
}): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        ...sx,
      }}
    >
      {postAuthor && (
        <PostMessageSection author={postAuthor} onMessagePost={onMessagePost} />
      )}
      {children}
    </Box>
  );
};
